/**
 * Assignment Courses Tab Component
 * Shows list of courses in the assignment
 */

import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
} from '@mui/material'
import { CourseIcon } from 'src/v3/core/icons'

interface CoursesTabProps {
  assignment: any
}

export default function CoursesTab({ assignment }: CoursesTabProps) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Assigned Courses ({assignment.courses.length})
      </Typography>

      {assignment.courses.length === 0 ? (
        <Typography
          color="text.secondary"
          sx={{ fontStyle: 'italic', py: 4, textAlign: 'center' }}
        >
          No courses assigned to this assignment.
        </Typography>
      ) : (
        <List dense sx={{ maxHeight: 400, overflow: 'auto' }}>
          {assignment.courses.map((course: any, index: number) => (
            <ListItem
              key={course.id || index}
              sx={{
                px: 0,
                py: 1,
                borderBottom:
                  index < assignment.courses.length - 1 ? '1px solid' : 'none',
                borderColor: 'divider',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  width: '100%',
                }}
              >
                <CourseIcon sx={{ color: 'primary.main' }} />
                <ListItemText
                  primary={
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {course.name || course.title || `Course ${index + 1}`}
                    </Typography>
                  }
                  secondary={
                    <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                      {course.category && (
                        <Chip
                          label={course.category}
                          size="small"
                          variant="outlined"
                          color="primary"
                        />
                      )}
                      {course.ceHours && (
                        <Chip
                          label={`${course.ceHours} CE Hours`}
                          size="small"
                          variant="outlined"
                          color="success"
                        />
                      )}
                      {course.licenseTypes &&
                        course.licenseTypes.length > 0 && (
                          <Chip
                            label={course.licenseTypes.join(', ')}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                    </Box>
                  }
                />
              </Box>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}
